module.exports = __webpack_public_path__ + "img/camera_close.241ba113.png";